module.exports = __webpack_public_path__ + "static/media/a2.65b83bd6.jpg";